import * as amplify from "../../util/amplify.ts";
import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import { markValidNative, markInvalidNative } from "../../util/forms.ts";
import ApiServer from "../../ApiServer.ts";
import * as i18n from "../../i18n.ts";
import {getCache} from "../../server/objects/BudgetBeans.ts";
import MAIN_MODAL from "../../budget/modal_paymentmethod.mustache";
import MAIN_MODAL_HIDDEN from "../../budget/modal_paymentmethod_hidden.mustache";
import TPL_ITEM from "../../budget/modal_paymentmethod_item.mustache";
import { registerDragStart } from "../../lib/FileUtils.ts";

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();


Html.registerDom({
  budgetpaymentuihidden(){
    modal.closeDomModal();
    const theModalHidden = modal.openDomModal(MAIN_MODAL_HIDDEN,{paymentmethod:budgetPaymentMethodCache.hidden()});

    const icons = theModalHidden.querySelectorAll("flexrow>icon");
    icons.forEach(icon => {
      icon.addEventListener('click', function(){
        const metaIdNode = Html.getDomMetaIdNode(this);
        const metaId = Html.getDomMetaId(metaIdNode);
        const category = budgetPaymentMethodCache.get(metaId);

        category.hidden = false;
        ApiServer.budgetpaymentmethodput(category,function(){
          const visibleNodes = theModalHidden.querySelectorAll('[data-fw-meta-id]:not([style*="display: none"])');
          if(visibleNodes.length > 1){
            metaIdNode.style.display = 'none';
          }else{
            metaIdNode.remove();
            const emptyEl = theModalHidden.querySelector('.empty') as HTMLElement;
            if(emptyEl) emptyEl.style.display = '';
          }
        })
        budgetPaymentMethodCache.refresh()
      });
    });

    theModalHidden.onClose = function(){
      Html.trigger(null,"budgetpaymentmethodmanage")
    }

    function updateUI(){
      const visibleNodes = theModalHidden.querySelectorAll('[data-fw-meta-id]:not([style*="display: none"])');
      const emptyEl = theModalHidden.querySelector('.empty') as HTMLElement;
      if(emptyEl) {
        emptyEl.style.display = visibleNodes.length === 0 ? '' : 'none';
      }
    }
    updateUI()
  },

  budgetpaymentmethodmanage(){
    let modified = false;

    const theModal = modal.openDomModal(MAIN_MODAL,{paymentmethod:budgetPaymentMethodCache.filtered()})
    const buttonAdd = theModal.querySelector('button') as HTMLButtonElement;

    const inputs = theModal.querySelectorAll('input');
    inputs.forEach(input => {
      input.addEventListener('keypress', function(ev){
        if(ev.keyCode===13 || ev.keyCode===10){
          ev.preventDefault();
          this.blur();
        }
      });
    });

    theModal.onClose = function(){
      if(modified){
        amplify.publish('budgetNeedRefresh')
      }
    }

    if(buttonAdd) {
      buttonAdd.addEventListener('click', function(){
        const goodGroup = theModal.querySelector('div.paymentlist') as HTMLElement;
        const catNode = Html.setHtmlAtEndDom(goodGroup,TPL_ITEM,{emoji:'💰',rights:{canUpdate:true,canDelete:true}});
        const input = catNode.querySelector('input') as HTMLInputElement;
        if(input) input.focus();
      });
    }

    // Event delegation for input change
    theModal.addEventListener('change', Html.createDelegateListener('input', function(evt, target){
      const catnode = target.closest('flexrow') as HTMLElement;
      if(!catnode) return;

      const nameInput = catnode.querySelector('[name=name]') as HTMLInputElement;
      const name = nameInput?.value;
      if(!name){
        markInvalidNative(catnode, i18n.get('budget.paymentmethoderrors.noname'));
        catnode.focus();
        return;
      }

      const emojiInput = catnode.querySelector('[name=emoji]') as HTMLInputElement;
      const metaId = Html.getDomMetaId(catnode);

      ApiServer.budgetpaymentmethodput({metaId, emoji:emojiInput?.value, name},function(newCat){
        modified = true;
        const newNode = Html.replaceWithSingleDom(catnode,TPL_ITEM,newCat);
        markValidNative(newNode);
      },function(err){
        if(err.code==='63'){
          markInvalidNative(catnode, i18n.get('budget.paymentmethoderrors.63'));
          catnode.focus();
        }else{
          throw err;
        }
      })
    }));

    // Event delegation for delete icons
    theModal.addEventListener('click', Html.createDelegateListener('flexrow>icon[data-type="delete"]', function(evt, target){
      const catnode = target.closest('flexrow') as HTMLElement;
      if(!catnode) return;

      const metaId = Html.getDomMetaId(catnode);
      if(!metaId){
        catnode.style.display = 'none';
      } else{
        ApiServer.budgetpaymentmethoddelete(metaId,function(){
          modified = true;
          catnode.style.display = 'none';
        })
        budgetPaymentMethodCache.refresh()
      }
    }));
  }
})


registerDragStart(".paymentlist>*",async function(ev,dropPromiseBuilder){
  const movingNode = this;
  const potentialDrop = Array.from(document.querySelectorAll('.paymentlist>*'));
  const dropEvent = await dropPromiseBuilder(this,potentialDrop);
  const dropNode = Html.getDomMetaIdNode(dropEvent.target as HTMLElement);

  let nodeBefore: HTMLElement | null = null;
  const dropRect = dropNode.getBoundingClientRect();
  if(dropRect.top + dropRect.height/2 > dropEvent.clientY){
    nodeBefore = dropNode.previousElementSibling as HTMLElement;
    dropNode.parentElement?.insertBefore(movingNode, dropNode);
  }else{
    nodeBefore = dropNode;
    if(dropNode.nextElementSibling){
      dropNode.parentElement?.insertBefore(movingNode, dropNode.nextElementSibling);
    }else{
      dropNode.parentElement?.appendChild(movingNode);
    }
  }

  const movingMetaId = Html.getDomMetaId(movingNode);
  const beforeMetaId = nodeBefore ? Html.getDomMetaId(nodeBefore) : null;
  ApiServer.budgetpaymentmethodput({metaId:movingMetaId, prevId:beforeMetaId||"$empty"},function(){})
  amplify.publish('budgetNeedRefresh')
})
